var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExpanded = function SvgExpanded(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4375 16 16 12.4062 16 8C16 3.5625 12.4375 -3.11444e-07 8 -6.99382e-07C3.59375 -1.08459e-06 1.43701e-06 3.5625 1.04907e-06 8C6.63867e-07 12.4062 3.59375 16 8 16ZM4.21875 8.21875L7.46875 4.71875C7.59375 4.5625 7.8125 4.5 8 4.5C8.21875 4.5 8.4375 4.5625 8.5625 4.71875L11.8125 8.21875C12.0313 8.4375 12.0625 8.75 11.9375 9.03125C11.8438 9.3125 11.5625 9.5 11.25 9.5L4.75 9.5C4.46875 9.5 4.1875 9.3125 4.09375 9.03125C3.96875 8.75 4 8.4375 4.21875 8.21875Z",
    fill: "#868686"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpanded, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expanded.e17c85f6.svg";
export { ForwardRef as ReactComponent };